import lozad from 'lozad'
import Swiper, {Navigation, Thumbs} from 'swiper'
import {indicatorSlide, scrollAnimation} from '../index/scripts/helper'
import {header} from '../index/scripts/header'
import { home } from '../index/scripts/home'
$(document).ready(function () {
	header.init()
	scrollAnimation()
	about.init()
	CountUpNumber()
	indicatorSlide()
	calOffsetLeft()
	home.video()
})
/*==================== Calculate offset left Our Differences ====================*/
function calOffsetLeft() {
	const widthWrap = $('.section-about-content').outerWidth()
	const widthContainer = $(
		'.section-about-content .container-dynamic'
	).outerWidth()
	const offsetLeft = (widthWrap - widthContainer) / 2
	$('.section-about-content .title-32').attr(
		'style',
		`--offsetLeft: ${offsetLeft}px`
	)
}
/*==================== Count Up ====================*/
function CountUpNumber() {
	var nodeCount = $('.countup')
	const options = {
		duration: 3,
		separator: '.',
		enableScrollSpy: true,
	}
	var nodeAnimation
	nodeCount.each(function (index) {
		var value = $(nodeCount[index]).data('number')
		nodeAnimation = new countUp.CountUp(nodeCount[index], value, options)
		nodeAnimation.start()
	})
}
/*==================== About - History  ====================*/
const about = {
	slide: function () {
		var thumb = new Swiper('.section-about-history .swiper-thumbs', {
			slidesPerView: 1,
			speed: 1000,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				768: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 4,
				},
				1200: {
					slidesPerView: 6,
				},
			},
		})
		var main = new Swiper(
			'.section-about-history .wrap-swiper-about-history .swiper',
			{
				slidesPerView: 1,
				spaceBetween: 16,
				rewind: true,
				speed: 1000,
				navigation: {
					nextEl: '.section-about-history .btn-next',
					prevEl: '.section-about-history .btn-prev',
				},
				on: {
					slideChange: function () {
						var totalSlide = main.slides.length - 1
						var previousIndex = this.previousIndex
						var currentIndex = this.activeIndex
						if (previousIndex == 0 && this.isEnd) {
							this.slideTo(totalSlide - 1)
						}
						if (previousIndex != 0 && this.isEnd) {
							this.slideTo(0)
						}
					},
				},
				modules: [Thumbs, Navigation],
				thumbs: {
					swiper: thumb,
				},
				breakpoints: {
					768: {
						slidesPerView: 1,
					},
					1024: {
						slidesPerView: 1.248,
					},
				},
			}
		)
		new Swiper('.section-about-leader .swiper', {
			slidesPerView: 2,
			speed: 1000,
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 5,
				},
			},
		})
	},
	init: function () {
		about.slide()
	},
}

/*==================== Lazyload JS ====================*/
const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()
